import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow bg-white pt-20 md:pt-24">
        <div className="container mx-auto px-6 md:px-4 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl font-medium text-gray-800 mb-4 font-trends">
              Cookie Policy
            </h1>
            <h2 className="text-xl sm:text-2xl text-gray-800 mb-6 font-trends">
              Chase the Chickens
            </h2>
            <p className="text-gray-600 mb-8">Effective Date: January 12, 2025</p>

            <p className="text-lg md:text-xl text-gray-800 mb-8">
              This Cookie Policy explains how Chase the Chickens uses cookies and similar technologies on our website and app.
            </p>

            {/* Sections */}
            <div className="space-y-8 md:space-y-12">
              {/* What Are Cookies */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">1. What Are Cookies?</h2>
                <p className="text-gray-600">
                  Cookies are small files stored on your device to enhance user experience. They help us understand how users interact with our website and app.
                </p>
              </section>

              {/* Types of Cookies */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">2. Types of Cookies We Use</h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Essential Cookies:</strong> Necessary for website functionality, such as signing in and game setup.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Performance Cookies:</strong> Help us analyze site usage and improve features.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Functional Cookies:</strong> Remember your preferences and settings.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Targeting Cookies:</strong> Deliver personalized ads and track the effectiveness of campaigns.</span>
                  </li>
                </ul>
              </section>

              {/* Managing Cookies */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">3. Managing Cookies</h2>
                <p className="text-gray-600">
                  You can control cookies through your browser settings. Disabling cookies may affect your experience and limit certain features.
                </p>
              </section>

              {/* Third-Party Cookies */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">4. Third-Party Cookies</h2>
                <p className="text-gray-600">
                  We may allow trusted third parties, such as analytics providers (e.g., Google Analytics), to set cookies. These parties have their own privacy policies.
                </p>
              </section>

              {/* Updates */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">5. Updates to this Policy</h2>
                <p className="text-gray-600">
                  We may revise this policy to reflect changes in technology or legislation. Significant updates will be communicated on this page.
                </p>
              </section>

              {/* Contact Section */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">Contact Us</h2>
                <p className="text-gray-600 mb-4">For questions about our use of cookies, please contact us at:</p>
                <div className="space-y-2 text-gray-600">
                  <p><strong>Email:</strong> privacy@chasethechickens.co.uk</p>
                  <p><strong>Mail:</strong> Rock Software, 123 Game Street, London, UK</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CookiePolicy;